import React from 'react';

import { getCmsValue } from '../../../utils/utils';
import { ShoppingCart } from '../../_common/Icons';
import { toggleCartOpen } from '../../../state/shopService';

const Buy = ({ addToCartTitle, available, site, ...props }) => {
  const addToCart = (e) => {
    const { product, selectedVariant } = props;
    props.addLineItem(selectedVariant.shopId);
    props.dispatch(toggleCartOpen(true, site.siteUID));

    props.onAddToCart(product, selectedVariant, 'Variant Selector View');
  };

  const classNames = [!available ? 'add-to-cart-button--disabled' : ''].join(
    ' '
  );

  return (
    <div className="cta__add-to-cart">
      <button
        className={`cta__add-to-cart-button ${classNames}`}
        onClick={available ? addToCart : undefined}
      >
        {ShoppingCart}
        {addToCartTitle ||
          getCmsValue(site.strings.productCTA__addToCartButton, site)}
      </button>
    </div>
  );
};

export default Buy;
